var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.receiptTemplate && _vm.receipts)?_c('Receipt',{attrs:{"receipt-template":_vm.receiptTemplate,"receipts":_vm.receipts,"template":2,"print-header":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }